// extracted by mini-css-extract-plugin
export default {"row":"priceDetailsItem-module__row__Or7yl","label":"priceDetailsItem-module__label__2MiqJ","price":"priceDetailsItem-module__price__LcWBE"};